import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as WelcomeCouple } from "../../../../assets/welcomeCouple.svg";
import {
  MobileView,
  NavigationPanelBreakPoint,
  SingleViewPerLayoutBreakPoint,
} from "../../../../util/aKaunGeneralUtil";
import { LandingPageMessage } from "../landingPageMessage";
import { LandingPageImage } from "../landingPageImage";
import { DeviceStoreIcon } from "fe-common/ui/icons/deviceStoreIcon";
//region [[ Styles ]]

const WhoAreYouTopSectionView = styled("div")(({ theme }) => ({
  display: "flex",
  height: "100%",
  width: "100%",
  alignItems: "center",
  marginBottom: "15px",
  paddingTop: "15px",
  [theme.breakpoints.down(SingleViewPerLayoutBreakPoint)]: {
    textAlign: "center",
    padding: "15px 25px 0 25px",
    width: "auto",
    marginBottom: "5px",
  },
}));

const WhoAreYouMessage = styled(LandingPageMessage)(({ theme }) => ({
  "& .description-text": {
    [theme.breakpoints.down(MobileView)]: {
      display: "none",
    },
  },
}));

const WhoAreYouImage = styled(LandingPageImage)(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    display: "none",
  },
}));

const StoreIcons = styled(DeviceStoreIcon)(({ theme }) => ({
  flexFlow: "row",
  "& svg:first-of-type": {
    marginRight: "11px",
  },
  "& svg": {
    height: "47px",
    [theme.breakpoints.down(MobileView)]: {
      height: "53px",
      margin: "11px 0",
    },
    width: "auto",
  },
  [theme.breakpoints.up(NavigationPanelBreakPoint)]: {
    justifyContent: "flex-start",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WhoAreYouTopSectionProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

//region [[ Texts ]]
const WELCOME_TO_KAHUN = "Welcome to Kahun";

const WELCOME_SUBTITLE = "Mapped medical knowledge at your fingertips";

const WELCOME_DESCRIPTION_TEXT =
  "We combine the incredible power of AI with the latest clinical knowledge to " +
  "give guided help with diagnosis, anamnesis, workup planning, and access to " +
  "clinical reasoning.";
//endregion [[ Texts ]]

export const WhoAreYouTopSection = ({ ...props }: WhoAreYouTopSectionProps) => {
  return (
    <WhoAreYouTopSectionView>
      <WhoAreYouMessage
        upperTitle={WELCOME_TO_KAHUN}
        mainTitle={WELCOME_SUBTITLE}
        descriptionText={WELCOME_DESCRIPTION_TEXT}
        extraElement={<StoreIcons />}
      />
      <WhoAreYouImage Image={WelcomeCouple} />
    </WhoAreYouTopSectionView>
  );
};
